import {BaseAppModel} from "./AppModel";

export default class DeviceHardwareStatus extends BaseAppModel<DeviceHardwareStatus> {
    battery?: number = undefined
    network?: number = undefined
}
